import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { Vehicle, PurchaseMethods, ModelYear } from '@sm360/widget-commons-vehicle';
import 'build-and-quote/components/Summary/components/Disclaimers/Disclaimers.scss';

class Disclaimers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            disclaimers: this.getDisclaimers(props.modelYear, props.vehicle),
        };

        this.getDisclaimers = this.getDisclaimers.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.vehicle && this.props.vehicle !== nextProps.vehicle) {
            PurchaseMethods.DisclaimerAPIService.getVehiclesDisclaimers([nextProps.vehicle]).then(
                ([vehicleWithDisclaimers]) => {
                    this.setState({
                        disclaimers: this.getDisclaimers(this.props.modelYear, vehicleWithDisclaimers),
                    });
                }
            );
        } else if (this.props.modelYear && this.props.modelYear !== nextProps.modelYear) {
            const selectedOptionsPackage = this.props.modelYear.getSelectedOptionsPackage();
            PurchaseMethods.DisclaimerAPIService.getModelYearSelectedOptionsPackageDisclaimers(
                nextProps.modelYear,
                selectedOptionsPackage,
                selectedOptionsPackage.configuration.configurationToken
            ).then((modelYearWithDisclaimers) => {
                this.setState({
                    disclaimers: this.getDisclaimers(modelYearWithDisclaimers),
                });
            });
        }
    }

    getDisclaimers(modelYear, vehicle) {
        if (vehicle && vehicle.purchaseMethods && vehicle.purchaseMethods.disclaimers) {
            const { disclaimers } = vehicle.purchaseMethods;
            switch (vehicle.purchaseMethods.getSelectedPurchaseMethodValue()) {
                case PurchaseMethods.PurchaseMethodsValues.FINANCE:
                    return disclaimers.finance;
                case PurchaseMethods.PurchaseMethodsValues.LEASE:
                    return disclaimers.lease;
                case PurchaseMethods.PurchaseMethodsValues.CASH:
                    return disclaimers.cashPurchase;
                default:
                    return null;
            }
        } else {
            const currentDisclaimers =
                modelYear &&
                modelYear.getSelectedOptionsPackageConfiguration() &&
                modelYear.getSelectedOptionsPackageConfiguration().purchaseMethods.getDisclaimersForCurrentMethod();
            return currentDisclaimers;
        }
    }

    render() {
        const { purchaseMethods } = this.props;
        const contentZoneLegalDisclaimer = ContentZonesService.getContentZone(
            'widget.build.and.buy',
            'widget.build.and.buy.legal.disclaimer'
        );

        const legalDisclaimerCz = contentZoneLegalDisclaimer ? contentZoneLegalDisclaimer.getValue() : '';
        let genericDisclaimers;

        if (this.props.vehicle) {
            const vehiclePurchaseMethods = this.props.vehicle.purchaseMethods;
            genericDisclaimers = vehiclePurchaseMethods &&
                vehiclePurchaseMethods.disclaimers && [
                    vehiclePurchaseMethods.disclaimers.dataResponsibility,
                    vehiclePurchaseMethods.disclaimers.priceChange,
                ];
        } else {
            genericDisclaimers = purchaseMethods &&
                purchaseMethods.disclaimers && [
                    purchaseMethods.disclaimers.dataResponsibility,
                    purchaseMethods.disclaimers.priceChange,
                ];
        }

        return (
            <div className="sr-disclaimer">
                <Vehicle.VehicleDisclaimersContent
                    disclaimers={this.state.disclaimers}
                    disclaimersContentZone={legalDisclaimerCz}
                    genericDisclaimers={genericDisclaimers}
                    onOrderDisclaimer
                />
            </div>
        );
    }
}

Disclaimers.defaultProps = {
    vehicle: {},
};

Disclaimers.propTypes = {
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel),
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
};

function mapStateToProps(state) {
    return {
        modelYear: state.modelYear,
        purchaseMethods: state.purchaseMethods,
    };
}

Disclaimers.displayName = 'Disclaimers';

export { Disclaimers };
export default connect(mapStateToProps)(Disclaimers);
